interface Props {
  missingCount: number;
}

export default function AvailabilityBanner({ missingCount }: Props) {
  if (missingCount === 0) return null;

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl px-4 py-3 mb-4">
      <div className="flex items-center gap-2">
        <svg className="w-5 h-5 text-amber-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        <div>
          <p className="text-sm font-semibold text-amber-800 dark:text-amber-200">Set Your Availability</p>
          <p className="text-xs text-amber-600 dark:text-amber-400">
            {missingCount} event{missingCount > 1 ? 's' : ''} need{missingCount === 1 ? 's' : ''} your driving availability
          </p>
        </div>
      </div>
    </div>
  );
}
